import { createRouter, createWebHistory } from 'vue-router';

import Market from '@/views/market.vue';
import FAQ from '@/views/FAQ.vue';
import MarketCollections from '@/components/market/collections.vue';
import NftGalleryDetail from '@/components/market/galleryDetail.vue';

const routes = [
  { path: '/', redirect: { name: 'marketCollections' } },
  {
    path: '/market',
    name: 'market',
    component: Market,
    children: [{
      path: '',
      name: 'marketCollections',
      component: MarketCollections,
    }, {
      path: 'nft/:id',
      name: 'marketNftDetail',
      component: NftGalleryDetail,
    }],
  },
  { path: '/FAQ', name: 'FAQ', component: FAQ },
  { path: '/:pathMatch(.*)*', redirect: { name: 'marketCollections' } },
];

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
